<div class="inner">
  <div class="info">
    <h1 class="title">{{ title() }}</h1>
    @if (showCallDetails()) {
      <button qai-link class="view-call-details-link" (click)="handleViewCallDetailsClick()">
        {{ 'learningPathway.VIEW_CALL_DETAILS' | transloco }}
      </button>
      <app-practice-call-details-modal
        [title]="title()"
        [callDetails]="callDetails()"
        (modalOpened)="callDetailsModalOpened.emit()"
        (modalClosed)="callDetailsModalClosed.emit()"
      />
    }
  </div>

  <div class="settings">
    @if (showDownloadIcon()) {
      <button
          qai-icon-button
          data-testid="download-icon-btn"
          [icon]="'download'"
          [kind]="'primary-default'"
          [size]="'24px'"
          (click)="handleDownloadClick()"
          >
          {{ 'learningPathway.DOWNLOAD' | transloco }}
       </button>
    }

    @if (showHelpIcon()) {
      <button
          qai-icon-button
          data-testid="help-icon-btn"
          [icon]="'help-circle'"
          [kind]="'primary-default'"
          [size]="'24px'"
          (click)="handleHelpIconClick()"
          >
          {{ 'learningPathway.HELP' | transloco }}
       </button>
    }

    @if (showSettings()) {
      <button
          qai-icon-button
          [icon]="'settings'"
          [kind]="'primary-default'"
          [size]="'24px'"
          (click)="handleSettingsClick()"
          >
          {{ 'learningPathway.SETTINGS' | transloco }}
       </button>
    }

    <button
        qai-button
        kind="default"
        size="xsmall"
        shape="circle"
        type="button"
        aria-label="Close"
        class="close-rounded"
        (click)="handleLeaveStepClick()"
        >
        <qai-icon positionStart [kind]="'x-close'" [size]="'16px'" />
     </button>
  </div>
</div>
